export const RESPONSE_TIME_PAGE_FILTER = "responseTime";
export const ANSWER_RATE_PAGE_FILTER = "answerRate";
export const CSAT_PAGE_FILTER = "csat";
export const PRESALE_PAGE_FILTER = "presale";